export interface PrintableSummaryProps {
  head: string;
  tab: string;
}

/**
 * This template is a top-level HTML file that's hard to get working with React, to just use a plain
 * string template instead.
 */
export default function renderPrintableSummary(args: PrintableSummaryProps): string {
  // TODO: Clean this up to use a plain string template. The current code is an artifact of needing
  // to compare with Jade.
  // prettier-ignore
  return (
    // eslint-disable-next-line prefer-template
    '<!DOCTYPE html>' +
    '<html lang="en">' +
      '<head>' +
        args.head +
      '</head>' +
      '<body ' +
        'onload="setTimeout(function() { return window.print(); }, 1000);" ' +
        'class="printable-summary-container"' +
      '>' +
        args.tab +
      '</body>' +
    '</html>'
  );
}
